// =========================================================
// * Vue Material Kit PRO - v1.2.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-kit-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import axios from "axios";
//import moment from "moment";
import App from "./App.vue";
import "element-ui/lib/theme-chalk/index.css";
import router from "./router";
import store from "./store";

// Plugins
import VueAxios from "vue-axios";
import MaterialKit from "./plugins/material-kit";


Vue.config.productionTip = false;

Vue.use(MaterialKit);
Vue.use(VueAxios, axios);
Vue.material.locale.dateFormat = "yyyy-MM-dd";

Vue.filter('formatNumber', function(value) {
    return new Intl.NumberFormat('en-US', {
      maximumSignificantDigits: 3
    }).format(value);
  });
  

const app = new Vue({
    router: router,
    store: store,
    el: "#app",
    data: {
     isInit: false,
     options: {} 
    },
    beforeCreate: function() {
      if ( this.$store.getters['isLoggedIn'] ) {
        this.$store.dispatch("me/getProfile").then(() => {
        }, error => {
          this.$store.dispatch("logout");
        });

      }

      this.$store.dispatch("options/init").then(() => {
          this.options = this.$store.state.options;
          this.isInit = true;
      });
    }, 
    render: h => h(App)
});
  
store.$app = app;